import { createContext, useContext } from "react";
const noop = async () => { };
export const WalletDescriptorLoaderContext = createContext({ loadById: noop, loadAll: async () => { } });
export const useWalletDescriptorLoader = () => useContext(WalletDescriptorLoaderContext);
